/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorDocumentDto } from '../../models/vendor-document-dto';

export interface VendorDocumentControllerFindAllByClientId$Params {
  clientWorkspaceId: string;
}

export function vendorDocumentControllerFindAllByClientId(http: HttpClient, rootUrl: string, params: VendorDocumentControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorDocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorDocumentControllerFindAllByClientId.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorDocumentDto>>;
    })
  );
}

vendorDocumentControllerFindAllByClientId.PATH = '/api/vendorDocument/all/{clientWorkspaceId}';
